<template>
  <div class="home" ref="home">
    <!-- <header class="header">
      <div class="header-box">
        <bs-select
          placeholder="English"
          :value.sync="selectLanguageId"
          :options="selectLanguage"
          @change="changeSelect"
          suffix-icon="bs-icon-caret-bottom-language"
          type="dark"
          style="width: 110px"
          :selectAll="false"
        ></bs-select>
      </div>
    </header> -->
    <aside class="aside" :class="{ 'fixed-bottom': isFixed }" ref="aside">
      <div class="aside-box">
        <div class="bs-logo">
          <img src="../../assets/image/icon/bs-logo.png" alt="" />
        </div>
        <div class="search-box">
          <div class="select">
            <div class="select-title">Country</div>
            <bs-select
              placeholder="Please Select"
              :value.sync="countryId"
              :options="address"
              @change="changeCountry"
              type="light"
            ></bs-select>
          </div>
          <div class="select">
            <div class="select-title">City</div>
            <bs-input
              style="width: 100%"
              v-if="!showSelectState"
              size="medium"
              placeholder="Search by City"
              v-model.trim="state"
            ></bs-input>
            <bs-select
              v-else
              placeholder="Please Select"
              :value.sync="stateId"
              :options="stateAddress"
              @change="changeState"
              type="dark"
            ></bs-select>
          </div>
          <div class="select">
            <div class="select-title">Zip/Postal Code</div>
            <bs-input
              style="width: 100%"
              placeholder="Search by Zip/Postal Code"
              v-model.trim="postal"
            ></bs-input>
          </div>
          <!-- <div class="select">
            <textarea
              class="address-text"
              placeholder="Search by Address, City or Zip/Postal Code"
              v-model.trim="state"
            ></textarea>
          </div> -->
          <div class="select select-last">
            <div class="select-title">Dealer</div>
            <bs-select
              placeholder="Please Select"
              :value.sync="selectAgencyId"
              :options="agencyAllList"
              @change="changeAgency"
              type="light"
            ></bs-select>
          </div>
          <div class="flex-between">
            <bs-button type="info" style="width: 100%" @click="search"
              >SEARCH</bs-button
            >
          </div>
        </div>
        <div class="custom-box">
          <div class="custom-title">
            <i class="bs-icon-email-white mr8"></i>service@sharkgulf.com
          </div>
          <div class="divider"></div>
          <div class="custom-title">
            <i class="bs-icon-company mr8"></i>© 2019 blueshark.com All rights
            reserved. 沪ICP备18039357号-1
          </div>
        </div>
      </div>
    </aside>
    <div class="main flexcol-between">
      <article class="content flex-center-center">
        <div class="agency-list">
          <!-- <div class="agency-list" v-if="!loading"> -->
          <div class="agency-list-content" v-if="agencyList.length > 0">
            <ul class="image-box">
              <li v-for="item in agencyList" :key="item.Id">
                <div
                  class="image"
                  :style="{ backgroundImage: 'url(' + item.url + ')' }"
                ></div>
                <div class="agency-content">
                  <div class="agency-name">{{ item.name }}</div>
                  <div class="opening-hours">
                    Business hours: {{ item.open_hour }}
                  </div>
                  <div class="agency-item">
                    <span>TEl:</span>{{ item.telephone }}
                  </div>
                  <div class="agency-item address">
                    <span>Add:</span>{{ item.address }}
                  </div>
                  <div class="agency-item">
                    <span>Mail:</span>{{ item.email }}
                  </div>
                  <div class="agency-item">
                    <span>P.C:</span>{{ item.post_code }}
                  </div>
                  <div class="agency-item">
                    <span>Web:</span>{{ item.website }}
                  </div>
                </div>
              </li>
            </ul>
            <div class="pagination-box">
              <bs-pagination
                @change="changeCurrentpage"
                :currentPage="currentPage"
                :total="total"
                :pageSize="pageSize"
              ></bs-pagination>
            </div>
          </div>
          <div class="doc-content text-center" v-else>
            <img class="empty-img" src="../../assets/image/nodata.png" alt="" />
            <p>Sorry, we can't find anything</p>
          </div>
        </div>
      </article>
      <footer class="footer">
        <div class="footer-box">
          <div class="copy-right">
            <img
              class="bs-logo"
              src="../../assets/image/icon/blueshark-logo.png"
              alt=""
            />
            <span class="cldark"
              >© 2019 blueshark.com All rights reserved.
              沪ICP备18039357号-1</span
            >
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import BsButton from "./packages/button";
import BsSelect from "./packages/select";
import BsTitle from "./packages/title";
import BsPagination from "./packages/pagination";
import address from "../../assets/js/rmiaddress";
import BsInput from "./packages/input";
export default {
  name: "Home",
  components: {
    BsButton,
    BsSelect,
    BsTitle,
    BsPagination,
    BsInput,
  },
  data() {
    return {
      visible: false,
      isFixed: false,
      selectAgencyId: -1,
      // selectLanguage: [
      //   {
      //     id: 1,
      //     name: "English",
      //   },
      // ],
      // selectLanguageId: 1,
      currentPage: 1,
      pageSize: 3,
      total: 0,
      agencyList: [],
      agencyAllList: [],
      address: address,
      countryId: "",
      country: "",
      stateId: "",
      state: "",
      agencyName: "",
      loading: false,
      postal: "",
      stateAddress: [],
      showSelectState: false,
    };
  },
  mounted() {
    // console.log("api",process.env.VUE_APP_API)
    // let md5text=md5("rueqwou")
    // console.log("md5",md5text)
    this.getAgencyList();
    this.getAllList();
    this.$nextTick(function () {
      window.addEventListener("scroll", this.handleScroll);
    });
  },
  methods: {
    changeCountry(e) {
      if (e.id != -1) {
        let index = address.findIndex((item) => {
          return item.id == e.id;
        });
        let stateAddress = address[index].child;
        this.stateAddress = stateAddress;
        this.country = address[index].name;
        this.state = "";
        this.stateId = -1;
      } else {
        this.country = "";
        this.state = "";
        this.stateId = -1;
        this.stateAddress = [];
      }
      if (this.stateAddress.length > 0) {
        this.showSelectState = true;
      } else {
        this.showSelectState = false;
      }
    },
    changeState(e) {
      if (e.id != -1) {
        let index = this.stateAddress.findIndex((item) => {
          return item.id == e.id;
        });
        this.stateId = e.id;
        this.state = this.stateAddress[index].name;
      } else {
        this.state = "";
      }
    },
    // changeSelect(val) {
    //   // console.log(val);
    // },
    handleScroll() {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      let asideHeight = this.$refs.aside.offsetHeight;
      let homeHeight = this.$refs.home.offsetHeight;
      if (homeHeight > asideHeight) {
        if (scrollTop >= asideHeight - windowHeight) {
          this.isFixed = true;
        } else {
          this.isFixed = false;
        }
      }
    },
    changeAgency(e) {
      console.log(e, "e");
      if (e.id != -1) {
        this.selectAgencyId = e.id;
        this.agencyName = this.agencyAllList[e.index].name;
      } else {
        this.agencyName = "";
      }
      console.log(e);
    },
    getAgencyList() {
      this.loading = true;
      let req = {
        page: this.currentPage,
        page_size: this.pageSize,
        country: this.country,
        city: this.state,
        postal: this.postal,
        company: this.agencyName,
      };
      this.$source
        .post("/rmi/front/company/list", req, API_HOST_RMI)
        .then((response) => {
          let res = response.body;
          let agencyList = res.data.list;
          agencyList.forEach((item) => {
            if (item.pic[0]) {
              item.url = res.data.domain + item.pic[0];
              item.id = item.Id;
              item.name = item.company_name;
            }
          });
          this.total = res.data.total;
          this.agencyList = agencyList;
          this.loading = false;
        });
    },
    getAllList() {
      let that = this;
      let req = {
        page: 1,
        page_size: 10000,
        country: "",
        city: "",
        postal: "",
        company: "",
      };
      this.$source
        .post("/rmi/front/company/list", req, API_HOST_RMI)
        .then((response) => {
          let res = response.body;
          let agencyList = res.data.list;
          agencyList.forEach((item) => {
            item.url = res.data.domain + item.pic[0];
            item.id = item.Id;
            item.name = item.company_name;
          });
          this.agencyAllList = agencyList;
        });
    },
    search() {
      this.currentPage = 1;
      this.getAgencyList();
    },
    changeCurrentpage(page) {
      this.currentPage = page;
      this.getAgencyList();
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/icon.less";
textarea,
input {
  font-family: "Helvetica Neue", "Helvetica", "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "SimSun", "sans-serif";
}
// ::-webkit-input-placeholder {
//   color: #0f1720;
// }
// ::-moz-placeholder {
//   color: #0f1720;
// }
// ::-o-input-placeholder {
//   color: #0f1720;
// }
// ::-ms-input-placeholder {
//   color: #0f1720;
// }
.home {
  font-size: 14px;
  .header {
    box-sizing: border-box;
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    height: 72px;
    width: 100%;
    padding-left: 280px;
    background: #fff;
    box-shadow: 0px 5px 10px 0px rgba(6, 42, 66, 0.1);
    .header-box {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      padding: 0 32px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .homepage {
        cursor: pointer;
        &:hover {
          color: #0091f2;
        }
      }
      .mr8 {
        margin-right: 8px;
      }
    }
  }
  .aside {
    position: absolute;
    top: 0;
    left: 0;
    box-sizing: border-box;
    width: 280px;
    // min-height: 100vh;
    background: #0f1720;
    z-index: 3;
    .aside-box {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      min-height: 100vh;
      padding: 20px 24px 240px;
      .bs-logo {
        box-sizing: border-box;
        height: 155px;
        line-height: 155px;
        text-align: center;
        padding-top: 40px;
        margin-bottom: 16px;
        cursor: pointer;
        img {
          width: 75px;
        }
      }
      .select {
        color: #0192f3;
        margin-bottom: 24px;
        .select-title {
          height: 16px;
          font-size: 14px;
          margin-bottom: 16px;
        }
        // .address-text {
        //   box-sizing: border-box;
        //   width: 100%;
        //   height: 150px;
        //   padding: 12px;
        //   color: #0f1720;
        //   outline: none;
        //   font-size: 14px;
        //   line-height: 18px;
        //   border: 1px solid #5c6166;
        //   resize: none;
        //   &:hover {
        //     border: 1px solid #0192f3;
        //   }
        // }
      }
      .select-last {
        margin-bottom: 36px;
      }
      .custom-box {
        position: absolute;
        bottom: 40px;
        left: 0;
        padding: 0 24px;
        color: #8a9199;
        font-size: 14px;
        line-height: 20px;
        .custom-title {
          font-size: 14px;
        }
        .mr8 {
          margin-right: 8px;
        }
        .divider {
          width: 200px;
          height: 1px;
          background: #e6ebf0;
          margin: 11px 0;
        }
      }
    }
  }
  .fixed-bottom {
    position: fixed;
    top: auto;
    bottom: 0;
  }
  .main {
    // position: relative;
    // z-index: 2;
    box-sizing: border-box;
    min-height: 100vh;
    padding: 0 0 0 280px;
    // padding: 72px 0 0 280px;
    background: #e6ebf0;
    .agency-list {
      background: #e6ebf0;
      .agency-list-content {
        padding: 40px 50px;
        width: 1040px;
        margin: 0 auto;
        .image-box {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          li {
            list-style: none;
            margin: 16px 16px 16px 0;
            width: 336px;
            background: #fff;
            .image {
              width: 336px;
              height: 252px;
              background: #fff;
              background-repeat: no-repeat;
              background-position: 50%;
              background-size: cover;
            }
            &:nth-child(3n) {
              margin-right: 0;
            }
            .agency-content {
              box-sizing: border-box;
              height: 292px;
              padding: 32px 16px 0;
              // background: #fff;
              background: url(../../assets/image/agency-bg.png) right bottom /
                120px 120px no-repeat;
              .agency-name {
                font-size: 16px;
                color: #0f1720;
                font-weight: 600;
                line-height: 16px;
                margin-bottom: 12px;
              }
              .opening-hours {
                font-size: 14px;
                color: #0091f2;
                line-height: 14px;
                margin-bottom: 24px;
              }
              .agency-item {
                font-size: 14px;
                color: #5c6166;
                line-height: 14px;
                margin-bottom: 12px;
                span {
                  color: #0f1720;
                  font-weight: 600;
                }
              }
              .address {
                line-height: 21px;
              }
            }
          }
        }
        .pagination-box {
          margin-top: 16px;
        }
      }
      .doc-content {
        text-align: center;
        .empty-img {
          height: 160px;
          margin: 0px 0 20px;
        }
        p {
          font-size: 16px;
          color: #8a9199;
          line-height: 16px;
        }
      }
    }
    .content {
      flex: 1;
      overflow: auto;
      // min-height: calc(100vh - 483px);
    }
    .footer {
      background: #fff;
      .footer-box {
        // padding: 30px 40px 0;
        font-size: 14px;
        .copy-right {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 78px;
          padding: 0 40px;
          color: #8a9199;
          span {
            font-size: 14px;
          }
          .bs-logo {
            width: 175px;
          }
        }
      }
    }
  }
}
.flexcol-between {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.flex-center-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter, .list-leave-to
/* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
</style>



// WEBPACK FOOTER //
// src/components/en/dealer.vue